export function groupBy(list: any[], groupKey: string, removeUndefined = true) {
  const grouped = {};
  list?.forEach((item) => {
    const key = item[groupKey];
    const collection = grouped[key];
    if (!collection) {
      grouped[key] = [item];
    } else {
      collection.push(item);
    }
  });

  if (removeUndefined) {
    Object.keys(grouped).forEach((key) => {
      if (key === 'undefined' || key === 'Degree') {
        delete grouped[key];
      }
    });
  }

  return grouped;
}
